// BDEPerformanceDashboard.tsx (You should also rename the file)
import { Layout, Row, Col } from 'antd';
import React from 'react';
import BdePipeline from './BdePipeline';
import SalesSummary from './SalesSummary';
import TargetVsAchieved from './TargetVsAchieved';


const { Content } = Layout;


const BDEPerformanceDashboard: React.FC = () => (
    <Layout >
        <Content>

          <div className="mb-6">  <BdePipeline /></div>

            <Row gutter={[24, 24]}>

                <Col xs={24} lg={10} style={{ display: 'flex', width: "100%" }}>
                    <SalesSummary />
                </Col>
                <Col xs={24} lg={14} style={{ display: 'flex', width: "100%" }}>
                    <TargetVsAchieved />
                </Col>
            </Row>
        </Content>
    </Layout>
);

export default BDEPerformanceDashboard;